/**
 * ProjectEntity Class file
 *
 * Generated file, don't touch manually
 *
 * ModelVersion: 90004
 */
import { BaseEntity } from "@archipad-js/core/orm";
import { ProjectTemplateVersionEntity } from "../ProjectTemplateVersionEntity";
import { PhaseEntity } from "../PhaseEntity";
import { BugWorkflowEntity } from "../BugWorkflowEntity";
import { RegionTypeEntity } from "../RegionTypeEntity";
import { RegionEntity } from "../RegionEntity";
import { MapEntity } from "../MapEntity";
import { PersonEntity } from "../PersonEntity";
import { ProjectMemberEntity } from "../ProjectMemberEntity";
import { WorkPackageEntity } from "../WorkPackageEntity";
import { VisitTypeEntity } from "../VisitTypeEntity";
import { ProjectUserRoleEntity } from "../ProjectUserRoleEntity";
import { ProjectUserRightEntity } from "../ProjectUserRightEntity";
import { ProjectUserEntity } from "../ProjectUserEntity";
import { VisitEntity } from "../VisitEntity";
import { PlanningEventCategoryEntity } from "../PlanningEventCategoryEntity";
import { PlanningEventGroupEntity } from "../PlanningEventGroupEntity";
import { PlanningEventEntity } from "../PlanningEventEntity";
import { PlanningEventDependencyEntity } from "../PlanningEventDependencyEntity";
import { CalendarModificationEntity } from "../CalendarModificationEntity";
import { FormTypeEntity } from "../FormTypeEntity";
import { BugEntity } from "../BugEntity";
import { RemarkStyleEntity } from "../RemarkStyleEntity";
import { RemarkCategoryEntity } from "../RemarkCategoryEntity";
import { RemarkCategoryHierarchyEntity } from "../RemarkCategoryHierarchyEntity";
import { RemarkEntity } from "../RemarkEntity";
import { DocumentEntity } from "../DocumentEntity";
import { ReportGroupEntity } from "../ReportGroupEntity";
import { ReportEntity } from "../ReportEntity";
import { ProjectEntity } from "../ProjectEntity";
declare global {
    interface EntityTypeMap {
        Project: ProjectEntity;
    }
}
export abstract class ProjectGeneratedEntity extends BaseEntity {
    public abstract projectId: string;
    public abstract originTemplateIds: string | null;
    public abstract language: string | null;
    public abstract name: string | null;
    public abstract address: string | null;
    public abstract demolitionPermit: string | null;
    public abstract buildingPermit: string | null;
    public abstract typeOfWork: string | null;
    public abstract townHallAddress: string | null;
    public abstract unitOfMeasure: string | null;
    public abstract demolishedBuildingsSurface: number | null;
    public abstract landArea: number | null;
    public abstract floorSurface: number | null;
    public abstract buildingHeight: number | null;
    public abstract currency: string | null;
    public abstract estimatedDemolitionBudget: number | null;
    public abstract estimatedConstructionBudget: number | null;
    public abstract realDemolitionBudget: number | null;
    public abstract realConstructionBudget: number | null;
    public abstract estimatedStartDate: Date | null;
    public abstract estimatedEndDate: Date | null;
    public abstract realStartDate: Date | null;
    public abstract realEndDate: Date | null;
    public abstract type: string | null;
    public abstract country: string | null;
    public abstract buildingsQuantity: number | null;
    public abstract closeDate: Date | null;
    public abstract settingDotSize: number | null;
    public abstract settingHotBugDuration: number | null;
    public abstract settingLateBugForVisitDuration: number | null;
    public abstract settingDotColorFunction: string;
    public abstract settingEventColorFunction: string;
    public abstract settingAutoAcceptanceOfBug: boolean;
    public abstract settingAllowClosingBugFromAnyVisit: boolean;
    public abstract settingWeekdaysData: number;
    public abstract settingHolidaysCountry: string | null;
    public abstract settingHolidaysState: string | null;
    public abstract settingHolidaysRegion: string | null;
    public abstract formAspects: string | null;
    public abstract dependencies: string | null;
    public abstract referenceDate: Date | null;
    public abstract isSampleProject: number | null;
    public abstract estimatedOverallBudget: number | null;
    public abstract realOverallBudget: number | null;
    public abstract estimatedCostSurface: number | null;
    public abstract realCostSurface: number | null;
    public abstract promoimmo_ref_projet: string | null;
    public abstract promoimmo_moa: string | null;
    public abstract promoimmo_moa_addr: string | null;
    public abstract promoimmo_date_reception: Date | null;
    public abstract readonly templateVersions: ReadonlyArray<ProjectTemplateVersionEntity>;
    public abstract readonly phases: ReadonlyArray<PhaseEntity>;
    public abstract bugWorkflow: BugWorkflowEntity | null;
    public abstract readonly regionTypes: ReadonlyArray<RegionTypeEntity>;
    public abstract readonly regions: ReadonlyArray<RegionEntity>;
    public abstract readonly maps: ReadonlyArray<MapEntity>;
    public abstract readonly people: ReadonlyArray<PersonEntity>;
    public abstract readonly members: ReadonlyArray<ProjectMemberEntity>;
    public abstract readonly workPackages: ReadonlyArray<WorkPackageEntity>;
    public abstract readonly visitTypes: ReadonlyArray<VisitTypeEntity>;
    public abstract readonly userRoles: ReadonlyArray<ProjectUserRoleEntity>;
    public abstract readonly userRights: ReadonlyArray<ProjectUserRightEntity>;
    public abstract readonly users: ReadonlyArray<ProjectUserEntity>;
    public abstract owner: ProjectUserEntity | null;
    public abstract readonly visits: ReadonlyArray<VisitEntity>;
    public abstract readonly planningEventCategories: ReadonlyArray<PlanningEventCategoryEntity>;
    public abstract readonly planningEventGroups: ReadonlyArray<PlanningEventGroupEntity>;
    public abstract readonly planningEvents: ReadonlyArray<PlanningEventEntity>;
    public abstract readonly planningEventDependencies: ReadonlyArray<PlanningEventDependencyEntity>;
    public abstract readonly calendarModifications: ReadonlyArray<CalendarModificationEntity>;
    public abstract readonly formTypes: ReadonlyArray<FormTypeEntity>;
    public abstract readonly bugs: ReadonlyArray<BugEntity>;
    public abstract readonly remarkStyles: ReadonlyArray<RemarkStyleEntity>;
    public abstract readonly remarkCategories: ReadonlyArray<RemarkCategoryEntity>;
    public abstract readonly remarkCategoryHierarchies: ReadonlyArray<RemarkCategoryHierarchyEntity>;
    public abstract readonly remarks: ReadonlyArray<RemarkEntity>;
    public abstract readonly ownedDocuments: ReadonlyArray<DocumentEntity>;
    public abstract readonly documents: ReadonlyArray<DocumentEntity>;
    public abstract readonly reportGroups: ReadonlyArray<ReportGroupEntity>;
    public abstract readonly reports: ReadonlyArray<ReportEntity>;
}
